
// List of inappropriate words/phrases to filter out
const INAPPROPRIATE_WORDS = [
  'sex', 'porn', 'nude', 'naked', 'sexual', 'xxx', 'adult', 'explicit',
  'erotic', 'intimate', 'seductive', 'sensual', 'arousing', 'stimulating',
  'provocative', 'suggestive', 'inappropriate', 'vulgar', 'obscene',
  'profane', 'offensive', 'disturbing', 'violent', 'graphic', 'mature',
  'nsfw', 'r-rated', 'x-rated', 'fetish', 'kinky', 'lustful', 'dirty',
  'naughty', 'steamy', 'risque', 'scandalous', 'taboo', 'forbidden'
];

export const validateContent = (text: string): { isValid: boolean; message?: string } => {
  if (!text || text.trim().length === 0) {
    return { isValid: false, message: "Content cannot be empty" };
  }

  const lowerText = text.toLowerCase();
  
  // Check for inappropriate words
  for (const word of INAPPROPRIATE_WORDS) {
    if (lowerText.includes(word.toLowerCase())) {
      return { 
        isValid: false, 
        message: "Please choose an appropriate topic suitable for educational writing" 
      };
    }
  }

  return { isValid: true };
};

export const validateTopicContent = (topic: string): { isValid: boolean; message?: string } => {
  if (!topic || topic.trim().length === 0) {
    return { isValid: false, message: "Please enter a topic" };
  }

  if (topic.trim().length < 3) {
    return { isValid: false, message: "Topic must be at least 3 characters long" };
  }

  if (topic.trim().length > 200) {
    return { isValid: false, message: "Topic must be less than 200 characters" };
  }

  return validateContent(topic);
};
